import { useContext } from 'react';
import { Field } from 'redux-form';
import { CommanderFormContext } from '@mews-commander/ui';
import { Checkbox } from '@optimus-web/core';
import { getError } from '../../utils';

interface CheckboxFieldRendererProps {
    input?: $TSFixMe; // TODO: pt.shape(fieldInputPropTypes) from redux-form
    meta?: $TSFixMe; // TODO: pt.shape(fieldMetaPropTypes) from redux-form
    disabled?: boolean;
}

const CheckboxFieldRenderer = ({
    input: { value, name, onChange },
    meta,
    // @ts-expect-error $TSFixMeError: Property 'label' does not exist on type 'CheckboxFieldRendererProps'.
    label,
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type 'CheckboxFieldRendererProps'.
    scope,
    disabled,
    ...other
}: CheckboxFieldRendererProps) => {
    const { readOnlyForm } = useContext(CommanderFormContext);
    const handleChange = (event: $TSFixMe, checked: $TSFixMe) => {
        onChange(checked);
    };

    return (
        <Checkbox
            error={getError(meta)}
            checked={value}
            name={name}
            onChange={handleChange}
            id={`${name}-${scope}`}
            disabled={readOnlyForm || disabled}
            {...other}
        >
            {label}
        </Checkbox>
    );
};

const CheckboxField = (props: $TSFixMe) => <Field component={CheckboxFieldRenderer} {...props} />;

export default CheckboxField;
